export default "__VITE_ASSET__BgoBYUQi__"